var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "8px",
    viewBox: "0 0 13 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(6.499587, 3.999977) rotate(-90.000000) translate(-6.499587, -3.999977) translate(2.999675, -2.000005)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25432511,1.11022302e-16 C6.43932511,1.11022302e-16 6.63732511,0.0700046577 6.78232511,0.223004658 C7.07232511,0.531004658 7.07232511,1.02000466 6.78232511,1.32700466 L1.78232511,6.00300466 L6.78232511,10.6640047 C7.07232511,10.9720047 7.07232511,11.4610047 6.78232511,11.7680047 C6.64897811,11.9133505 6.4615771,11.9972479 6.26434671,11.9999625 C6.06711632,12.0025477 5.87752893,11.9237155 5.74032511,11.7820047 L0.210325115,6.56200466 C0.0697653181,6.40959455 -0.00560420297,6.20825026 0.000325114847,6.00100466 C0.000325114847,5.79200466 0.0803251148,5.59700466 0.211325115,5.44300466 L5.74032511,0.223004658 C5.87299659,0.0801503587 6.05936726,-0.00070695356 6.25432511,1.11022302e-16 Z",
    id: "Path"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarat);
export default __webpack_public_path__ + "static/media/Carat.ad62725622959eb461b420f95dfae9db.svg";
export { ForwardRef as ReactComponent };